enum ProductStatus {
    PLANNED,
    STARTED,
    GIVE_UP,
    RELEASED,
    PRODUCTION,
}

export default ProductStatus